// @ts-nocheck
import { colors } from './styles/colors'

export const brand = {
  purpleBrand: colors.brandPrimary,
  purplePrimary: colors.brandPrimary,
  purpleDark: colors.brandPrimaryDark,
  purpleLight: colors.white,
  white: colors.white,
}

export const tokens = {
  colorPrimary: colors.brandPrimary,
  colorLink: colors.brandPrimary,
  colorBgBase: colors.white,
  colorBgLayout: colors.white,
  colorText: colors.textPrimary,
  borderRadius: 12,
  borderRadiusLG: 16,
  borderRadiusSM: 8,
  borderRadiusXS: 4,
  fontFamily: '"Google Sans", "Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
}
